import {useZero} from '@/shared/integrations/zero/use-zero'
import {SendPatientTherapySequenceEventSchema} from '@cypro/engine/mutators'
import {useCallback} from 'react'

export function useSendTherapySequenceEvent() {
  const zero = useZero()

  return useCallback(
    (payload: SendPatientTherapySequenceEventSchema) =>
      zero.attemptMutation(zero.mutators.patientsTherapies.sendEvent(payload), async mutation => await mutation.server),
    [zero]
  )
}
